import { useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';
import { fetchParameterValue } from '@/features/parameter/services/parameterService';
export const DEFAULT_TICKET_SUFFIX = 'UTMA';
const QUERY_KEY = ['parameter', 'SUFFIX_TICKET'];
const QUERY_STALE_TIME = 5 * 60 * 1000; // 5 minutes
const useTicketSuffix = () => {
    const { data, isLoading, isError, error } = useQuery(QUERY_KEY, () => fetchParameterValue('SUFFIX_TICKET'), {
        staleTime: QUERY_STALE_TIME,
        retry: false,
    });
    const ticketSuffix = useMemo(() => {
        const trimmed = data?.trim();
        return trimmed && trimmed.length > 0 ? trimmed : DEFAULT_TICKET_SUFFIX;
    }, [data]);
    const formatTicketCode = useCallback((id) => {
        if (id === undefined || id === null) {
            return ticketSuffix;
        }
        return `${ticketSuffix}-${id}`;
    }, [ticketSuffix]);
    return {
        ticketSuffix,
        formatTicketCode,
        isLoading,
        isError,
        error,
    };
};
export default useTicketSuffix;
